import { useState, useEffect } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import getTheme from '../theme/theme';
import { ThemeProvider } from '@mui/material';
import { BASEURL } from "../constants/Common";

interface FooterProps {
  copyright: string;
}

const Footer = (): JSX.Element => {
  const theme = getTheme();

  const [footer, setFooter] = useState<FooterProps[]>([]);

  const fetchFooter = () => {
    axios
      .get<FooterProps[]>(BASEURL + '/footer/', {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setFooter(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchFooter();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Grid container spacing={2} justifyContent="center">
        {footer.slice(0, 1).map((item, i) => (
          <Grid item xs={12} key={i}>
            <Typography
              align='center'
              variant='subtitle2'
              color={theme.palette.text.secondary}
              gutterBottom
              sx={{ marginBottom: '10px', textAlign: 'center', zIndex: 1, position: 'relative' }}
            >
              Copyright &copy; {new Date().getFullYear()} {item.copyright}.
            </Typography>
            <Typography
              align='center'
              variant='subtitle2'
              color={theme.palette.text.secondary}
              gutterBottom
              sx={{ textAlign: 'center', zIndex: 1, position: 'relative' }}
            >
              <a
                href="/Privacy Policy.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>{' '}
              &{' '}
              <a
                href="/Terms of Service.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>{' '}
              apply.
            </Typography>
          </Grid>
        ))}
      </Grid>
    </ThemeProvider>
  );
};

export default Footer;

